<template lang='pug'>
v-card
  v-container.pa-2(fluid)
    v-layout(align-center justify-space-between)
      v-layout(align-center @click="expandDescription = !expandDescription").clickable
        span.card-title Favorite Fields
      column-sorting.contact-card-settings(
        v-model="favoriteFields"
        @input="setFavorites"
        type="favorites"
        note="Note: This configuration will apply to all contact profiles."
      )
        template(slot="activator")
          v-btn(
            small
            color="transparent"
          ).pa-0.ma-0.card-action.clickable + Customize
      v-icon(color='#F7883E' @click="expandDescription = !expandDescription").clickable 
        | {{ expandDescription ? "keyboard_arrow_up" : "keyboard_arrow_down" }}
    v-layout(wrap row v-if="expandDescription").pt-3
      v-flex(
        xs12,
        v-for='(field, index) in filteredFavorites',
        :key='`favorite-${index}`',
      )
        field-value(
          v-if='isTextField(field)'
          v-model='contact[field.name]'
          is-profile-v2
          full-width
          :ref="field.name"
          :prependAction="phoneEmailAction"
          :error-types='fieldValueErrorTypes'
          :error-messages="fieldValueErrorMessages"
          :field-type='field.type'
          :dropdown-items='field.type === "select" ? field.items : null'
          :field-labels='labels'
          :field-label='field.label'
          :switch-off-label='field.offLabel'
          :is-switch-inverted='field.isInverted'
          :prepend-icon='field.icon'
          :mailUnsubscribed='field.text == "Primary Email" ? contact.unsubscribed : null'
          @field-status="fieldStatusChange"
          @input="addToPatchedFields($event, field)"
        )
        v-select.favorite-hotness.disabled-alternate.pa-0.ma-0(
          v-else-if='field.name === "hotness_id"'
          style="font-size: 15px"
          label='Hotness'
          :ref='field.name'
          :value='contact.hotness_id'
          :items='hotnesses'
          @input="addToPatchedFields($event, field)"
        )
          template(slot='prepend')
            v-icon(:color='hotnessColor') whatshot
        field-value(
          v-else
          v-model='field.value'
          prepend-icon='category'
          is-profile-v2
          full-width
          :ref="field.name"
          :fieldType='field.data_type'
          :validations="[validations[customFieldValidation(field.data_type)] || false]"
          :field-label='field.name'
          :is-custom-field='field.custom'
          @field-status="fieldStatusChange"
          @input="addToPatchedFields($event, field)"
        )
</template>
<script>
import FieldValue from '../../profile/FieldValue';

const ColumnSorting = () => 
  import(/* webpackChunkName: 'ColumnSorting' */ '@/Core/components/tables/ColumnSorting')


export default {
  name: 'DraggableCard',
  props: {
    isTextField: {
      type: Function,
    },
    phoneEmailAction: {
      type: Function,
    },
    customFieldValidation: {
      type: Function
    },
    filteredFavorites: {
      type: Array,
      default: {},
    },
    fieldValueErrorTypes: {
      type: Array,
      default: {},
    },
    fieldsForFavorites: {
      type: Array,
      default: {},
    },
    hotnesses: {
      type: Array,
      default: {},
    },
    contact: {
      type: Object,
      default: [],
    },
    fieldValueErrorMessages: {
      type: Object,
      default: [],
    },
    labels: {
      type: Object,
      default: [],
    },
    validations: {
      type: Object,
      default: []
    },
    hotnessColor: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      expandDescription: true,
      favoriteFields: this.fieldsForFavorites,
    };
  },
  components: {
    ColumnSorting,
    FieldValue,
  },
  watch: {
    fieldsForFavorites(newValue) {
      this.favoriteFields = newValue;
    },
  },
  methods: {
    setFavorites(sortedColumns) {
      this.$emit('set-favorites', sortedColumns);
    },
    addToPatchedFields(newValue, field) {
      const fieldValue = { 
        type: field.custom ? field.data_type.toLowerCase() : field.type,
        custom: field.custom,
        name: field.name,
        id: field.custom ? field.id : null,
      };
      this.$emit('input', newValue, fieldValue);
    },
    fieldStatusChange(field) {
      this.$emit('field-status-change', field);
    }
  },
};
</script>
<style lang="scss" scoped>
.card-title {
  color: #f7883e;
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 0.51px;
  line-height: 19px;
}
.card-action {
  color: #f7883e;
  font-size: 12px;
  letter-spacing: 0.44px;
  line-height: 16px;
  text-transform: none;
}
.clickable {
  cursor: pointer;
}
.remove-width {
  width: 0px;
}
</style>
